module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-timber-hamilton-1.8a6d1141.jpg";